import { render, staticRenderFns } from "./goodsPay.vue?vue&type=template&id=182a1d46&scoped=true&"
import script from "./goodsPay.vue?vue&type=script&lang=js&"
export * from "./goodsPay.vue?vue&type=script&lang=js&"
import style0 from "./goodsPay.vue?vue&type=style&index=0&id=182a1d46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182a1d46",
  null
  
)

export default component.exports